/*
Model defined for Maintaining Permission Responses. It can also be used for transferring model
*/
import { CurrencyModel } from './CurrencyModel';

export class CurrentRateModel {
    partnerId: string;
    productRates: productRates[];
}

export class productRates {
    product: string;
    rates: CurrencyModel[];
}



// WEBPACK FOOTER //
// ./src/app/_models/rates/CurrentRateModel.ts